import React from 'react';
import {
  StyledColorColumns,
  StyledColorColumn,
  StyledColorLabel,
  StyledColorSpan,
  StyledColorSpanInner,
  StyledTooltip,
} from '@components/Colors/Colors.styles';
import { Text } from '@components/typography';
import { SelectFilterOptions } from '@components/SelectFilter';

export interface SelectProps<T> {
  options: SelectFilterOptions;
  selectedOptions: string[];
  onClickedColor: (selectedColors: string[]) => void;
}

export const Colors = <T extends string>({ options, selectedOptions, onClickedColor }: SelectProps<T>) => {
  const handleChange = (name: string, isChecked: boolean) => {
    if (isChecked) {
      selectedOptions = [...selectedOptions, name];
    } else {
      selectedOptions = selectedOptions.filter((item) => item !== name);
    }
    onClickedColor(selectedOptions);
  };
  return (
    <StyledColorColumns multiline>
      {options.map((option, index) => (
        <StyledColorColumn width={'one-fifth'} key={index}>
          <StyledColorLabel
            className="container"
            onClick={(event) => {
              event.stopPropagation();
            }}
          >
            <input
              type="checkbox"
              checked={selectedOptions.some((item) => item === option.name)}
              onChange={(event) => {
                handleChange(option.name, event.currentTarget.checked);
              }}
            />
            <StyledColorSpan className="circle" backgroundColor={'ffffff'}>
              <StyledColorSpanInner className="circle-child tooltip" backgroundColor={option.value}>
                <StyledTooltip className="tooltiptext" width={68} left={-26}>
                  <Text color="white" variant="caption" tagName="div">
                    {option.name}
                  </Text>
                </StyledTooltip>
              </StyledColorSpanInner>
            </StyledColorSpan>
          </StyledColorLabel>
        </StyledColorColumn>
      ))}
    </StyledColorColumns>
  );
};
